import { Link } from 'react-router-dom';

import { Brand } from '@/components/shared/Brand';
import { Button, buttonVariants } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';

import { useSignOut } from '../hooks/useSignOut';

/**
 * A tela cheia que `RequireActiveAccount` mostra no lugar de qualquer rota
 * protegida, para uma conta bloqueada pela plataforma.
 *
 * ⚠️ **Não diz o motivo.** O bloqueio não registra motivo (D-01 do plano do
 * painel do admin — a fila de denúncias é o registro do porquê); inventar um
 * aqui seria pior que a ausência dele.
 *
 * `EmptyState` e não um layout autoral novo: é o mesmo caminho de
 * `RouteNotFound` (`src/routes/index.tsx`) para uma tela que **é** a página
 * inteira — o `titleAs="h1"` garante que o documento tenha um cabeçalho de
 * nível 1 para quem navega por eles.
 *
 * **Sair** encerra a sessão de verdade (o único jeito de destravar o app sem
 * esperar o admin desbloquear); **Ir para o mapa** mostra que a leitura pública
 * continua de pé, sem exigir esse encerramento.
 */
export function AccountSuspendedScreen() {
  const signOut = useSignOut();

  return (
    <main className="grid min-h-dvh place-items-center p-6">
      <EmptyState
        icon={<Brand variant="symbol" tone="on-light" className="w-16" />}
        title="Sua conta foi bloqueada"
        titleAs="h1"
        description="A plataforma bloqueou o acesso desta conta. Você continua podendo ver o mapa, os guias e os telefones de emergência, mas não dá para pedir socorro, participar de instituições nem publicar nada."
        action={
          <div className="flex flex-col gap-2">
            <Button
              fullWidth
              disabled={signOut.isPending}
              onClick={() => {
                signOut.mutate();
              }}
            >
              {signOut.isPending ? 'Saindo…' : 'Sair'}
            </Button>

            <Link to="/" className={buttonVariants({ variant: 'secondary', fullWidth: true })}>
              Ir para o mapa
            </Link>
          </div>
        }
      />
    </main>
  );
}
